import { fork, all } from 'redux-saga/effects'

import watchFetchExhibSaga from './exhibFloorSaga'
export default function* rootSaga() {
   yield all([
      fork(watchFetchExhibSaga),
   ]);
}